import { all, call, put, takeLatest } from 'redux-saga/effects';

import { logoutAgentAction } from '../actions/agentAuth';
import { requestAgentLogout } from '../../modules/b2b/auth/api';
import { AGENT_AUTH_ROUTE } from '../../modules/b2b/auth/config';
import { withAppBasePath } from '../../modules/appMode';
import { clearAgentSession } from '../reducers/agentAuth';
import { safeApply } from './errors';

function* logoutAgent() {
  yield call(requestAgentLogout);
  yield put(clearAgentSession());

  window.location.assign(withAppBasePath(AGENT_AUTH_ROUTE));
}

export default function* agentAuthSaga() {
  yield all([takeLatest(logoutAgentAction, safeApply(logoutAgent))]);
}
